import "../../../common/polyfills";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { CCEventRegForm } from "./EventRegForm";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";


function MountEventRegForm(props: any, el: Element) {
  ReactDOM.render(<GoogleReCaptchaProvider reCaptchaKey={props.reCaptchaSiteKey}><CCEventRegForm {...props} /></GoogleReCaptchaProvider>, el);
}

(window as any).MountEventRegForm = MountEventRegForm;